var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreatmentApproach2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22336",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 211.3 106.9",
    style: {
      enableBackground: "new 0 0 211.3 106.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#36393A;stroke-width:1.195;}\n\t.st2{fill:#FDE3DF;}\n\t.st3{fill:none;stroke:#FF2C46;stroke-width:1.271;}\n\t.st4{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 211.3,
    height: 106.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4243",
    className: "st1",
    d: "M206.4,106.8l1.4-16.2c0.4-6.3-4.1-11.8-10.3-12.5C172,75.1,107,95.9,0.2,67.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4244",
    className: "st1",
    d: "M200.6,0.1l4.5,22.2c1.1,6.2-2.8,12.1-8.9,13.6C171.1,41.7,104,53.5,8,42.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4245",
    className: "st2",
    d: "M194.4,76.2c0,0,1.7,5,3.1,5.2s4.8-13.8,5.2-15.9c0.3-2,0.3-4,0-6l-11.1,3.2L194.4,76.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4246",
    className: "st3",
    d: "M194.4,76.2c0,0,1.7,5,3.1,5.2s4.8-13.8,5.2-15.9c0.3-2,0.3-4,0-6l-11.1,3.2L194.4,76.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4247",
    className: "st2",
    d: "M189.1,76.2c0,0,2.4,7.4,3.6,7.6s3-6.9,3.5-9.1c0.4-2.1,3.6-13.5,3.5-15.6s-11.4,5.2-11.4,5.2 L189.1,76.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4248",
    className: "st3",
    d: "M189.1,76.2c0,0,2.4,7.4,3.6,7.6s3-6.9,3.5-9.1c0.4-2.1,3.6-13.5,3.5-15.6s-11.4,5.2-11.4,5.2 L189.1,76.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4249",
    className: "st2",
    d: "M179.4,73.4c0,0,0.3,12.6,6.6,12.5c1.8-0.2,2.8,0,8.7-24.5L182.6,60L179.4,73.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4250",
    className: "st3",
    d: "M179.4,73.4c0,0,0.3,12.6,6.6,12.5c1.8-0.2,2.8,0,8.7-24.5L182.6,60L179.4,73.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4251",
    className: "st2",
    d: "M162.5,68.9c0,0,5.3,13.5,7,15.5c1.3,1.6,2.9,2.4,3.9,2.3s4.3-3,5.6-8s3.5-18.1,3.5-18.1 L162,61.4L162.5,68.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4252",
    className: "st3",
    d: "M162.5,68.9c0,0,5.3,13.5,7,15.5c1.3,1.6,2.9,2.4,3.9,2.3s4.3-3,5.6-8s3.5-18.1,3.5-18.1 L162,61.4L162.5,68.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4253",
    className: "st2",
    d: "M142.9,67.5c0,0,2.7,10.6,3.9,13.8c0.7,2.4,2.3,4.5,4.5,5.8c2.2,1.5,6.5,3.8,9.1,3.2 s3.6-3.4,4-4.9c0.5-1.7,3.7-20.5,3-23.3c-0.8-2.7-5.8-5.5-5.8-5.5L142.9,67.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4254",
    className: "st3",
    d: "M142.9,67.5c0,0,2.7,10.6,3.9,13.8c0.7,2.4,2.3,4.5,4.5,5.8c2.2,1.5,6.5,3.8,9.1,3.2 s3.6-3.4,4-4.9c0.5-1.7,3.7-20.5,3-23.3c-0.8-2.7-5.8-5.5-5.8-5.5L142.9,67.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4255",
    className: "st4",
    d: "M119.4,64.7c0,0,2.5,10.6,3.8,14.6s3.3,9.2,7.6,10c4.3,0.8,7.7-0.5,8.3-3.8s5.7-17.3,5.5-19.3 s-3.4-5.5-5.4-6.9s-6.1-4-9.7-3.8S119.4,64.7,119.4,64.7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4256",
    className: "st1",
    d: "M119.4,64.7c0,0,2.5,10.6,3.8,14.6s3.3,9.2,7.6,10c4.3,0.8,7.7-0.5,8.3-3.8s5.7-17.3,5.5-19.3 s-3.4-5.5-5.4-6.9s-6.1-4-9.7-3.8S119.4,64.7,119.4,64.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4257",
    className: "st4",
    d: "M59.5,63.4c0,0,0.7,9.5,2.1,12.9c1.3,3.1,4.4,6.4,8.1,7.2c3.7,0.8,17,0.8,20.3-2.7 c2.2-2.2,3.8-5,4.4-8c0.6-2.3,2.7-8.3,1.8-10.4c-1-2.1-10-5.8-14.4-5.6S59.5,63.4,59.5,63.4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4258",
    className: "st1",
    d: "M59.5,63.4c0,0,0.7,9.5,2.1,12.9c1.3,3.1,4.4,6.4,8.1,7.2c3.7,0.8,17,0.8,20.3-2.7 c2.2-2.2,3.8-5,4.4-8c0.6-2.3,2.7-8.3,1.8-10.4c-1-2.1-10-5.8-14.4-5.6S59.5,63.4,59.5,63.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4259",
    className: "st4",
    d: "M96.3,63.8c0,0,1.6,7.2,3.3,12.4s2.9,10.3,8,10.2s7.2-2.4,8.1-6.3s2.7-8.2,3.3-10.6 s1.1-7.5,0.3-8.6s-11.4-4.5-11.4-4.5L96.3,63.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4260",
    className: "st1",
    d: "M96.3,63.8c0,0,1.6,7.2,3.3,12.4s2.9,10.3,8,10.2s7.2-2.4,8.1-6.3s2.7-8.2,3.3-10.6 s1.1-7.5,0.3-8.6s-11.4-4.5-11.4-4.5L96.3,63.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4261",
    className: "st4",
    d: "M26.2,60.3c-0.5,3.1-0.7,6.1-0.8,9.2c0.1,1.9,1.9,5.8,4,8.2c3,3.4,12.2,5.4,18.7,4.3 s12.1-14.2,12.1-14.8s-2.7-6.6-3.4-6.9c-2.2-0.7-4.4-1.4-6.7-1.9C49.8,58.6,26.2,60.3,26.2,60.3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4262",
    className: "st1",
    d: "M26.2,60.3c-0.5,3.1-0.7,6.1-0.8,9.2c0.1,1.9,1.9,5.8,4,8.2c3,3.4,12.2,5.4,18.7,4.3 s12.1-14.2,12.1-14.8s-2.7-6.6-3.4-6.9c-2.2-0.7-4.4-1.4-6.7-1.9C49.8,58.6,26.2,60.3,26.2,60.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4263",
    className: "st2",
    d: "M191.6,33.1c0,0,0-9.4,1.8-10.7s18.1,16.8,17.3,33.4c0,0,0,3.6-4.4,3.9c-2.2,0-4.3,0.4-6.4,1 L191.6,33.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4264",
    className: "st3",
    d: "M191.6,33.1c0,0,0-9.4,1.8-10.7s18.1,16.8,17.3,33.4c0,0,0,3.6-4.4,3.9c-2.2,0-4.3,0.4-6.4,1 L191.6,33.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4265",
    className: "st4",
    d: "M22.4,52.4c0,0,1.3-12.1,11.3-12.1s13.4,2.6,16.6,5.5s4.5,12.9,4.2,13.4s-5.1,6.6-11,6.8 c-3,0.1-7-4.8-8.9-4.9c-3.5-0.1-2.2,4.5-7,4.1C24.3,65,21.5,59.7,22.4,52.4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4266",
    className: "st1",
    d: "M22.4,52.4c0,0,1.3-12.1,11.3-12.1s13.4,2.6,16.6,5.5s4.5,12.9,4.2,13.4s-5.1,6.6-11,6.8 c-3,0.1-7-4.8-8.9-4.9c-3.5-0.1-2.2,4.5-7,4.1C24.3,65,21.5,59.7,22.4,52.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4267",
    className: "st4",
    d: "M85.1,49.1c0,0-6.2-10.6-10.3-11.8c-5-1.3-10.2-0.1-14.3,3c-4.9,4-7.3,15-5.3,21.1 c2,6.1,7.5,6.8,8.6,6.5c3.8-0.9,4.3-5.6,6.3-5.9c4-0.6,5.4,3,9.8,2.2c2.4-0.4,9.1-7.8,8.2-9.7S85.1,49.1,85.1,49.1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4268",
    className: "st1",
    d: "M85.1,49.1c0,0-6.2-10.6-10.3-11.8c-5-1.3-10.2-0.1-14.3,3c-4.9,4-7.3,15-5.3,21.1 c2,6.1,7.5,6.8,8.6,6.5c3.8-0.9,4.3-5.6,6.3-5.9c4-0.6,5.4,3,9.8,2.2c2.4-0.4,9.1-7.8,8.2-9.7S85.1,49.1,85.1,49.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4269",
    className: "st4",
    d: "M88.1,45.4c0,0-2.9,13-1,15.5s4.7,4.9,8.1,4.7s8.3-3,9.3-3.8c1.3-1.1,3.8-3.8,3.9-6.6 s-1.8-6.4-2.7-8.5s-3.3-11.7-10.3-12C89.4,34.5,88.1,45.4,88.1,45.4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4270",
    className: "st1",
    d: "M88.1,45.4c0,0-2.9,13-1,15.5s4.7,4.9,8.1,4.7s8.3-3,9.3-3.8c1.3-1.1,3.8-3.8,3.9-6.6 s-1.8-6.4-2.7-8.5s-3.3-11.7-10.3-12C89.4,34.5,88.1,45.4,88.1,45.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4271",
    className: "st4",
    d: "M109.7,43.8c0,0-3.1,13.8,0.3,16s9.6,5.7,11.8,5.3s8.3-7.8,9.9-8.8c1.1-0.6,1.7-1.8,1.6-3 c0-0.9-4-7.8-5.1-12s-4.2-11.6-10.9-11.1S109.7,43.8,109.7,43.8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4272",
    className: "st1",
    d: "M109.7,43.8c0,0-3.1,13.8,0.3,16s9.6,5.7,11.8,5.3s8.3-7.8,9.9-8.8c1.1-0.6,1.7-1.8,1.6-3 c0-0.9-4-7.8-5.1-12s-4.2-11.6-10.9-11.1S109.7,43.8,109.7,43.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4273",
    className: "st2",
    d: "M177.5,47.2c0,0,0.3-10.8,0.8-13.7c0.6-4,2.9-9.2,5.6-9.4s9.9,5.7,19.5,30.4c0,0,2.6,6-1.7,6.9 c-3.3,0.7-9.4,1.4-12.2,1.7c-1.2,0.1-2.3,0-3.4-0.3c-1.9-0.5-4.4-1.6-5.3-4C179.4,55,177.5,47.2,177.5,47.2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4274",
    className: "st3",
    d: "M177.5,47.2c0,0,0.3-10.8,0.8-13.7c0.6-4,2.9-9.2,5.6-9.4s9.9,5.7,19.5,30.4c0,0,2.6,6-1.7,6.9 c-3.3,0.7-9.4,1.4-12.2,1.7c-1.2,0.1-2.3,0-3.4-0.3c-1.9-0.5-4.4-1.6-5.3-4C179.4,55,177.5,47.2,177.5,47.2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4275",
    className: "st2",
    d: "M160.2,37.1c0,0,3.2-12.4,8.6-11.6c2.9,0.6,4.9,5.6,6.6,10.8s8.7,21.2,8.1,24.2 s-5.2,3.2-5.2,3.2l-7.6,0.6c-1.3,0.1-2.6-0.1-3.8-0.5c-1.7-0.6-3.9-1.7-4.9-3.4c-1.5-2.7-2.7-5.4-3.6-8.3 C158.2,47.1,158.8,42,160.2,37.1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4276",
    className: "st3",
    d: "M160.2,37.1c0,0,3.2-12.4,8.6-11.6c2.9,0.6,4.9,5.6,6.6,10.8s8.7,21.2,8.1,24.2 s-5.2,3.2-5.2,3.2l-7.6,0.6c-1.3,0.1-2.6-0.1-3.8-0.5c-1.7-0.6-3.9-1.7-4.9-3.4c-1.5-2.7-2.7-5.4-3.6-8.3 C158.2,47.1,158.8,42,160.2,37.1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4277",
    className: "st2",
    d: "M133.7,36.2c0,0.7,0.6,6.9,0.3,9.5c-0.2,1.5-2.9,6.9-0.1,10.4s7.1,10.7,16.1,9.5 s11.3-8.5,11.4-11.1c0.1-2.6-2-12.3-3.8-16.5c-1.8-4.4-8.1-13.8-16-12.7S133.7,36.2,133.7,36.2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4278",
    className: "st3",
    d: "M133.7,36.2c0,0.7,0.6,6.9,0.3,9.5c-0.2,1.5-2.9,6.9-0.1,10.4s7.1,10.7,16.1,9.5 s11.3-8.5,11.4-11.1c0.1-2.6-2-12.3-3.8-16.5c-1.8-4.4-8.1-13.8-16-12.7S133.7,36.2,133.7,36.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentApproach2);
export default __webpack_public_path__ + "static/media/treatment_approach_2.d0ee1d0f9b42ec9a1286ff52c91c8b8e.svg";
export { ForwardRef as ReactComponent };